import { useEffect, useState } from "react"
import { Input, Button, Table, Space, DatePicker, Modal } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'

const { Column } = Table
const { RangePicker } = DatePicker

type fetchParams = {
    brokerage_name: undefined | string
    uid: undefined | string
    nickname: undefined | string
    phone: undefined | string
    date: any
}

type fetchRecords1Params = {
    uid: undefined | string
    user_type: undefined | string
    keyword: undefined | string
    date: any
}

type fetchRecords2Params = {
    uid: undefined | string
    order_sn: undefined | string
    date: any
}

type fetchRecords3Params = {
    uid: undefined | string
    date: any
}

type pagination = {
    current: number
    pageSize: number
    total: number
    showSizeChanger: false
}

type paginationRecords1 = {
    current: number
    pageSize: number
    total: number
    showSizeChanger: false
}

type paginationRecords2 = {
    current: number
    pageSize: number
    total: number
    showSizeChanger: false
}

type paginationRecords3 = {
    current: number
    pageSize: number
    total: number
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        brokerage_name: undefined,
        uid: undefined,
        nickname: undefined,
        phone: undefined,
        date: null
    }

    let fetchRecords1ParamsTmpl: fetchRecords1Params = {
        uid: undefined,
        user_type: undefined,
        keyword: undefined,
        date: null
    }

    let fetchRecords2ParamsTmpl: fetchRecords2Params = {
        uid: undefined,
        order_sn: undefined,
        date: null
    }

    let fetchRecords3ParamsTmpl: fetchRecords3Params = {
        uid: undefined,
        date: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<any>([])
    const [dataSummary, setDataSummary] = useState<any>([])

    const [fetchRecords1Params, setFetchRecords1Params] = useState<fetchRecords1Params>(fetchRecords1ParamsTmpl)
    const [paginationRecords1, setPaginationRecords1] = useState<paginationRecords1>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [fetchRecords2Params, setFetchRecords2Params] = useState<fetchRecords2Params>(fetchRecords2ParamsTmpl)
    const [paginationRecords2, setPaginationRecords2] = useState<paginationRecords2>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [fetchRecords3Params, setFetchRecords3Params] = useState<fetchRecords3Params>(fetchRecords3ParamsTmpl)
    const [paginationRecords3, setPaginationRecords3] = useState<paginationRecords3>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [recordsID, setRecordsID] = useState<string | undefined>(undefined)

    const [visible1, setVisible1] = useState<boolean>(false)
    const [visible2, setVisible2] = useState<boolean>(false)
    const [visible3, setVisible3] = useState<boolean>(false)

    const [dataRecords1, setDataRecords1] = useState<any>([])
    const [dataRecords2, setDataRecords2] = useState<any>([])
    const [dataRecords3, setDataRecords3] = useState<any>([])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleRecords1Change = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchRecords1Params)
        params[attr] = value

        setFetchRecords1Params(params)
    }

    const handleRecords2Change = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchRecords2Params)
        params[attr] = value

        setFetchRecords2Params(params)
    }

    const handleRecords3Change = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchRecords3Params)
        params[attr] = value

        setFetchRecords3Params(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleRecords1Search = () => {
        const p = { ...pagination }
        p.current = 1

        fetchRecords1({ pagination: p, fetchRecords1Params })
    }

    const handleRecords2Search = () => {
        const p = { ...pagination }
        p.current = 1

        fetchRecords2({ pagination: p, fetchRecords2Params })
    }

    const handleRecords3Search = () => {
        const p = { ...pagination }
        p.current = 1

        fetchRecords3({ pagination: p, fetchRecords3Params })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const handleRecords1TableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPaginationRecords1(p)
    }

    const handleRecords2TableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPaginationRecords2(p)
    }

    const handleRecords3TableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPaginationRecords3(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.start_time = params.date[0].format('YYYY-MM-DD')
            params.end_time = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/finance_center/business/promoter/list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)

                baseAxiosNoInfo('/finance_center/business/promoter/summary', {
                    params: {
                        ...params
                    }

                }).then((res: any) => {
                    if (res) {
                        setDataSummary([res])
                    }
                })
            }

            setLoading(false)
        })
    }

    // 查询推广人列表
    const fetchRecords1 = ({ pagination, fetchRecords1Params }: { pagination: Object, fetchRecords1Params: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchRecords1Params }

        if (params.date) {
            params.start_time = params.date[0].format('YYYY-MM-DD')
            params.end_time = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/finance_center/business/promoter/spread_user_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPaginationRecords1(p)
                setDataRecords1(response.records)
            }
        })
    }

    // 查询推广订单
    const fetchRecords2 = ({ pagination, fetchRecords2Params }: { pagination: Object, fetchRecords2Params: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchRecords2Params }

        if (params.date) {
            params.start_time = params.date[0].format('YYYY-MM-DD')
            params.end_time = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/finance_center/business/promoter/spread_order_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPaginationRecords2(p)
                setDataRecords2(response.records)
            }
        })
    }

    // 查询佣金记录
    const fetchRecords3 = ({ pagination, fetchRecords3Params }: { pagination: Object, fetchRecords3Params: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchRecords3Params }

        if (params.date) {
            params.start_time = params.date[0].format('YYYY-MM-DD')
            params.end_time = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/finance_center/business/promoter/brokerage_records', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPaginationRecords3(p)
                setDataRecords3(response.records)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)

        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const resetRecords1Form = () => {
        let params: any = _.cloneDeep(fetchRecords1ParamsTmpl);
        params["uid"] = recordsID;

        setRecordsID(recordsID);
        setFetchRecords1Params(params);

        let p: any = { ...paginationRecords1 }
        p.current = 1
        setPaginationRecords1(p)

        fetchRecords1({ pagination: p, fetchRecords1Params: params })
    }

    const resetRecords2Form = () => {
        let params: any = _.cloneDeep(fetchRecords2ParamsTmpl);
        params["uid"] = recordsID;

        setRecordsID(recordsID);
        setFetchRecords2Params(params);

        let p: any = { ...paginationRecords1 }
        p.current = 1
        setPaginationRecords2(p)

        fetchRecords2({ pagination: p, fetchRecords2Params: params })
    }

    const resetRecords3Form = () => {
        let params: any = _.cloneDeep(fetchRecords3ParamsTmpl);
        params["uid"] = recordsID;

        setRecordsID(recordsID);
        setFetchRecords3Params(params);

        let p: any = { ...paginationRecords1 }
        p.current = 1
        setPaginationRecords3(p)

        fetchRecords3({ pagination: p, fetchRecords3Params: params })
    }

    const handleRecords1 = (value: string) => {
        let params: any = _.cloneDeep(fetchRecords1Params);
        params["uid"] = value;

        setRecordsID(value);
        setFetchRecords1Params(params);

        const p = { ...pagination };
        p.current = 1;

        fetchRecords1({ pagination: p, fetchRecords1Params: params });
    }

    const handleRecords2 = (value: string) => {
        let params: any = _.cloneDeep(fetchRecords2Params);
        params["uid"] = value;

        setRecordsID(value);
        setFetchRecords2Params(params);

        const p = { ...pagination };
        p.current = 1;

        fetchRecords2({ pagination: p, fetchRecords2Params: params });
    }

    const handleRecords3 = (value: string) => {
        let params: any = _.cloneDeep(fetchRecords3Params);
        params["uid"] = value;

        setRecordsID(value);
        setFetchRecords3Params(params);

        const p = { ...pagination };
        p.current = 1;

        fetchRecords3({ pagination: p, fetchRecords3Params: params });
    }

    return (<div className="common-page">
        {/* 财务中心 -> 经营管理 -> 分销管理 */}
        <BreadCrumb position={['财务中心', '分销管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["开始日期", "结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />

                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="分销员等级" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'brokerage_name') }} value={fetchOtherParams.brokerage_name} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="用户ID" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'uid') }} value={fetchOtherParams.uid} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="用户昵称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nickname') }} value={fetchOtherParams.nickname} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="用户手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'phone') }} value={fetchOtherParams.phone} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="uid" pagination={pagination} onChange={handleTableChange}>
                <Column fixed title="用户ID" dataIndex="uid" key="uid" />
                <Column fixed title="用户昵称" dataIndex="nickname" key="nickname" />
                <Column fixed title="用户手机号" dataIndex="phone" key="phone" />
                <Column title="推广用户数量" dataIndex="promoted_user_count" key="promoted_user_count" />
                <Column title="等级名称" dataIndex="level_name" key="level_name" />
                {/* <Column title="推广订单数量" dataIndex="promoted_order_count" key="promoted_order_count" />
                <Column title="推广订单金额" dataIndex="promoted_order_amount" key="promoted_order_amount" /> */}
                <Column title="签约订单数量" dataIndex="deal_order_count" key="deal_order_count" />
                <Column title="签约订单金额" dataIndex="deal_order_amount" key="deal_order_amount" />
                <Column title="佣金金额" dataIndex="commission_amount" key="commission_amount" />
                <Column title="已提现金额" dataIndex="withdrawn_amount" key="withdrawn_amount" />
                <Column title="提现次数" dataIndex="withdrawal_count" key="withdrawal_count" />
                <Column title="未提现金额" dataIndex="pending_withdraw_amount" key="pending_withdraw_amount" />
                <Column title="推广人ID" dataIndex="promoter_uid" key="promoter_uid" />
                <Column title="推广人昵称" dataIndex="promoter_nickname" key="promoter_nickname" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button size="small" onClick={() => {
                                setVisible1(true)
                                handleRecords1(record.uid)
                            }}>推广人</Button>

                            <Button size="small" onClick={() => {
                                setVisible2(true)
                                handleRecords2(record.uid)
                            }}>推广订单</Button>

                            <Button size="small" onClick={() => {
                                setVisible3(true)
                                handleRecords3(record.uid)
                            }}>佣金记录</Button>
                        </Space>
                    )}
                />
            </Table>
        </div>

        <div className="common-main">
            <h3>汇总</h3>

            <Table loading={loading} dataSource={dataSummary} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                <Column title="分销员人数" dataIndex="distributor_count" key="distributor_count" />
                <Column title="推广用户数" dataIndex="promoted_user_count" key="promoted_user_count" />
                {/* <Column title="推广订单数" dataIndex="promoted_order_count" key="promoted_order_count" />
                <Column title="推广订单金额" dataIndex="promoted_order_amount" key="promoted_order_amount" /> */}
                <Column title="签约订单数" dataIndex="deal_order_count" key="deal_order_count" />
                <Column title="签约订单金额" dataIndex="deal_order_amount" key="deal_order_amount" />
                <Column title="已提现金额" dataIndex="withdrawn_amount" key="withdrawn_amount" />
                <Column title="未提现金额" dataIndex="pending_withdraw_amount" key="pending_withdraw_amount" />
            </Table>
        </div>

        {/* 推广人列表 */}
        <Modal visible={visible1} title="推广人列表" width={1200} footer={null} onCancel={() => { setVisible1(false) }}>
            <div style={{ marginBottom: '10px' }}>
                <Space>
                    <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["开始日期", "结束日期"]} value={fetchRecords1Params.date} onChange={(v: any) => { handleRecords1Change(v, 'date') }} />
                    <Input style={{ marginRight: 8, marginBottom: 12 }} placeholder="匹配用户ID/昵称/手机号" onChange={(e: { target: { value: string } }) => { handleRecords1Change(e.target.value, 'keyword') }} value={fetchRecords1Params.keyword} />
                </Space>

                <div style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleRecords1Search}>查询</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetRecords1Form}>重置</Button>
                </div>
            </div>

            <Table dataSource={dataRecords1} bordered={true} pagination={paginationRecords1} onChange={handleRecords1TableChange} >
                <Column fixed title="用户ID" dataIndex="uid" key="uid" />
                <Column fixed title="用户昵称" dataIndex="nickname" key="nickname" />
                <Column fixed title="用户手机号" dataIndex="phone" key="phone" />
                <Column fixed title="推广人数" dataIndex="promoted_user_count" key="promoted_user_count" />
                {/* <Column fixed title="订单数量" dataIndex="order_count" key="order_count" /> */}
                <Column title="签约数量" dataIndex="deal_count" key="deal_count" />
                <Column title="签约金额" dataIndex="deal_amount" key="deal_amount" />
                <Column fixed title="绑定时间" dataIndex="bind_time" key="bind_time" />
                <Column fixed title="解绑时间" dataIndex="unbind_time" key="unbind_time" />
                <Column fixed title="关注时间" dataIndex="follow_time" key="follow_time" />
            </Table>
        </Modal>

        {/* 推广订单 */}
        <Modal visible={visible2} title="推广订单" width={1000} footer={null} onCancel={() => { setVisible2(false) }}>
            <div style={{ marginBottom: '10px' }}>
                <Space>
                    <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["开始日期", "结束日期"]} value={fetchRecords2Params.date} onChange={(v: any) => { handleRecords2Change(v, 'date') }} />
                    <Input style={{ marginRight: 8, marginBottom: 12 }} placeholder="订单号" onChange={(e: { target: { value: string } }) => { handleRecords2Change(e.target.value, 'order_sn') }} value={fetchRecords2Params.order_sn} />
                </Space>

                <div style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleRecords2Search}>查询</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetRecords2Form}>重置</Button>
                </div>
            </div>

            <Table dataSource={dataRecords2} bordered={true} pagination={paginationRecords2} onChange={handleRecords2TableChange} >
                <Column fixed title="订单ID" dataIndex="order_id" key="order_id" />
                <Column fixed title="订单号" dataIndex="order_sn" key="order_sn" />
                <Column fixed title="时间" dataIndex="time" key="time" />
                <Column fixed title="返佣金额" dataIndex="brokerage_amount" key="brokerage_amount" />
            </Table>
        </Modal>

        {/* 佣金记录 */}
        <Modal visible={visible3} title="佣金记录" width={1000} footer={null} onCancel={() => { setVisible3(false) }}>
            <div style={{ marginBottom: '10px' }}>
                <Space>
                    <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["开始日期", "结束日期"]} value={fetchRecords3Params.date} onChange={(v: any) => { handleRecords3Change(v, 'date') }} />
                </Space>

                <div style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleRecords3Search}>查询</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetRecords3Form}>重置</Button>
                </div>
            </div>

            <Table dataSource={dataRecords3} bordered={true} pagination={paginationRecords3} onChange={handleRecords3TableChange} >
                <Column fixed title="ID" dataIndex="bill_id" key="bill_id" />
                <Column fixed title="佣金金额" dataIndex="commission_amount" key="commission_amount" />
                <Column fixed title="获取时间" dataIndex="obtained_time" key="obtained_time" />
                <Column fixed title="备注" dataIndex="remark" key="remark" />
            </Table>
        </Modal>
    </div >)
}